module.exports = __webpack_public_path__ + "static/media/arachidi.ee45207d.svg";